export default (sliderId) => (
{
    swiper: null,
    init() {
        setTimeout(() => {
            this.swiper = new Swiper('.' + sliderId, {
                slidesPerView: 1,
                loop: true,
                spaceBetween: 0,
                a11y: true,
                navigation: {
                    nextEl: '.next-' + sliderId,
                    prevEl: '.prev-' + sliderId,
                },
                pagination: {
                    el: '.pag-' + sliderId,
                    // type: 'bullets',
                    clickable: true,
                    renderBullet: function (index, className) {
                        return '<div class="' + className + '"><div class="dot"></div></div>'
                    }
                },
                effect: 'fade'
            })
        }, 0)
    }
});
